import {getApiService, postApiService} from '../services/HttpService';
import Api from 'constants/Api';

export const USER_CONSTANTS = {
    REQUEST: 'USER_REQUEST',
    SUCCESS: 'USER_SUCCESS',
    FAILURE: 'USER_FAILURE',

    SIGNUP: 'USER_SIGNUP',
    VERIFICATION_REQUEST: 'USER_VERIFICATION_REQUEST',
    VERIFICATION_SUCCESS: 'USER_VERIFICATION_SUCCESS',
    VERIFICATION_FAILURE: 'USER_VERIFICATION_FAILURE',

    SET_INFO: 'USER_SET_INFO',
    SET_PLAN: 'USER_SET_PLAN',
    SET_DATA: 'USER_SET_DATA',
    RESET: 'USER_RESET',
    CLEAR: 'USER_CLEAR',
};
const handleVerificationRequest = payload => ({
    type: USER_CONSTANTS.VERIFICATION_REQUEST,
    payload
});
const handleVerifySuccess = payload => ({
    type: USER_CONSTANTS.VERIFICATION_SUCCESS,
    payload
});
const handleFailure = payload => ({
    type: USER_CONSTANTS.FAILURE,
    payload
});
const handleVerifyFailure = payload => ({
    type: USER_CONSTANTS.VERIFICATION_FAILURE,
    payload
});
const handleSetInfo = payload => ({
    type: USER_CONSTANTS.SET_INFO,
    payload
});
const handleSetPlan = payload => ({
    type: USER_CONSTANTS.SET_PLAN,
    payload
});
export const handleSetUserData = payload => dispatch => {
    dispatch({
        type: USER_CONSTANTS.SET_DATA,
        payload
    })

    return Promise.resolve()
}

export const handleUserVerification = payload => async dispatch => {
    const resend_result = await postApiService(
        Api.USER_REQUEST_VERIFY,
        payload,
        false);

    if (typeof resend_result.success !== 'undefined' && !resend_result.success) {
        dispatch(handleFailure(resend_result))
    } else {
        let {data} = resend_result;
        dispatch(handleVerificationRequest({
            requestDate: Date.now()
        }))
    }
};

export const handleUserVerify = payload => async dispatch => {
    const verify_result = await postApiService(
        Api.USER_REQUEST_VERIFY_TOKEN,
        payload,
        false);

    if (typeof verify_result.success !== 'undefined' && !verify_result.success) {
        dispatch(handleVerifyFailure(verify_result))
    } else {
        let {data} = verify_result;
        dispatch(handleVerifySuccess(data))
    }
};

export const handleGetInfo = token => async dispatch => {
    const request_result = await getApiService(Api.SESSION_GET_INFO, false, token);

    if (typeof request_result.success !== 'undefined' && !request_result.success) {
        dispatch(handleFailure(request_result))
    } else {
        let {data} = request_result;
        dispatch(handleSetInfo(data.results))
    }
};

export const handleGetPlan = token => async dispatch => {
    const request_result = await getApiService(Api.ACCOUNTING_GET_PLAN_DETAILS, false, token);

    if (typeof request_result.success !== 'undefined' && !request_result.success) {
        dispatch(handleFailure(request_result))
    } else {
        let {data} = request_result;
        dispatch(handleSetPlan(data.results.user_status))
    }
};

export const handleUserReset = () => dispatch => {
    dispatch({type: USER_CONSTANTS.RESET})

    return Promise.resolve()
};